import { Backdrop, CircularProgress } from "@mui/material";

const FullscreenLoader = ({ loading }) => {
  return (
    <Backdrop
      open={loading}
      sx={{ color: "#ffffff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <CircularProgress />
    </Backdrop>
  );
};
export default FullscreenLoader;